import React from "react";
import styled from "styled-components";
import {
  Flex,
  Box,
  AbsoluteFlex,
  Text,
  ExternalLink,
  Icon
} from "./Primitives";

const FooterWrapper = ({ ...props }) => (
  <Flex
    width={1}
    bg="background"
    justifyContent="center"
    alignItems="center"
    borderTop={1}
    borderColor="lines"
    css={{ height: "2em", position: "relative", overflow: "hidden" }}
    {...props}
  />
);

const leftKeys = {
  padding: "pl",
  position: "left"
};
const rightKeys = {
  padding: "pr",
  position: "right"
};
const SideContent = ({ left, right, ...props }) => {
  const sideKeys = left ? leftKeys : rightKeys;
  const sideProps = {
    [sideKeys.padding]: "1",
    [sideKeys.position]: "0"
  };
  return (
    <AbsoluteFlex
      alignItems="center"
      position="absolute"
      top="0"
      bottom="0"
      {...sideProps}
      {...props}
    />
  );
};
const FooterText = props => (
  <Text
    fontSize="0"
    letterSpacing="1"
    color="passive"
    width="auto"
    css={{ whiteSpace: "nowrap" }}
    {...props}
  />
);

const FooterIconWrapper = styled(({ ...props }) => {
  if (props.href) return <ExternalLink {...props} />;
  return <Box {...props} />;
})`
  &:hover {
    cursor: pointer; 
    background: ${({ theme }) => theme.colors.passive}
    color: ${({ theme }) => theme.colors.active}
  }
`;
const FooterIcon = ({ href, name, onClick, ...props }) => {
  if (href) {
    return (
      <FooterIconWrapper
        href={href}
        css={{ height: "100%" }}
        color="passive"
        {...props}
      >
        <Icon name={name} style={{ width: "32px" }} color="auto" />
      </FooterIconWrapper>
    );
  }
  if (onClick) {
    return (
      <FooterIconWrapper css={{ height: "100%" }} color="passive" {...props}>
        <Icon
          name={name}
          onClick={onClick}
          style={{ width: "32px" }}
          color="auto"
        />
      </FooterIconWrapper>
    );
  }
  return <Icon name={name} color="passive" {...props} />;
};
export const Footer = ({ children, ...props }) => {
  return (
    <FooterWrapper>
      <SideContent left>
        <FooterIcon name="gitBranch" />
        <FooterText pr="2">master</FooterText>
        <FooterIcon name="twitter" href="https://twitter.com/Anemolito" />
        <FooterIcon name="github" href="https://github.com/Anemolo" />
      </SideContent>
      <Box css="height: 100%">{children}</Box>
      <SideContent right>
        <FooterText>Design & developed with</FooterText>
        <FooterIcon name="hand" ml="4px" />
        <FooterIcon
          name="hand"
          mr="4px"
          style={{ transform: "rotateY(180deg)" }}
        />
        <FooterText>by me</FooterText>
        <FooterIcon ml="1" name="cookie" onClick={() => {}} />
      </SideContent>
    </FooterWrapper>
  );
};
